import { createContext, useContext, useMemo } from "react"

const CardapioContext = createContext(null)

export const useCardapioContext = () => {
    const context = useContext(CardapioContext)
    if (!context) {
        throw new Error("useCardapioContext deve ser usado dentro de CardapioProvider")
    }
    return context
}

export const CardapioProvider = ({ children, value }) => {
    const handlers = useMemo(
        () => ({
            handleSalvarProduto: value.handleSalvarProduto,
            handleDuplicarProduto: value.handleDuplicarProduto,
            handleExcluirProduto: value.handleExcluirProduto,
            handleCadastrarImagem: value.handleCadastrarImagem,

            handleSalvarCategoria: value.handleSalvarCategoria,
            handleDuplicarCategoria: value.handleDuplicarCategoria,
            handleExcluirCategoria: value.handleExcluirCategoria,

            handleCadastrarGrupoDeOpcao: value.handleCadastrarGrupoDeOpcao,
            handleExcluirGrupoDeOpcao: value.handleExcluirGrupoDeOpcao,
            handleDuplicarPassoDeMontagem: value.handleDuplicarPassoDeMontagem,

            handleCadastrarOpcao: value.handleCadastrarOpcao,
            handleExcluirOpcao: value.handleExcluirOpcao,

            handleIdsEditar: value.handleIdsEditar,
            handleSalvarCardapioInteiro: value.handleSalvarCardapioInteiro,
            handleToggleDuplicarGrupoDeMontagem: value.handleToggleDuplicarGrupoDeMontagem,

            handleAddInsumo: value.handleAddInsumo,
            handleDeleteInsumo: value.handleDeleteInsumo,
            salvarFt: value.salvarFt,
            buscarFT: value.buscarFT,
        }),
        [
            value.handleSalvarProduto,
            value.handleDuplicarProduto,
            value.handleExcluirProduto,
            value.handleCadastrarImagem,
            value.handleSalvarCategoria,
            value.handleDuplicarCategoria,
            value.handleExcluirCategoria,
            value.handleCadastrarGrupoDeOpcao,
            value.handleExcluirGrupoDeOpcao,
            value.handleDuplicarPassoDeMontagem,
            value.handleCadastrarOpcao,
            value.handleExcluirOpcao,
            value.handleIdsEditar,
            value.handleSalvarCardapioInteiro,
            value.handleToggleDuplicarGrupoDeMontagem,
            value.handleAddInsumo,
            value.handleDeleteInsumo,
            value.salvarFt,
            value.buscarFT,
        ]
    )

    const staticData = useMemo(
        () => ({
            estabelecimento: value.estabelecimento,
            cardapio: value.cardapio,
            insumos: value.insumos,
        }),
        [value.estabelecimento, value.cardapio, value.insumos]
    )

    const fichaTecnicaState = useMemo(
        () => ({
            insumoSelecionado: value.insumoSelecionado,
            insumosSelecionados: value.insumosSelecionados,
            fichaTecnica: value.fichaTecnica,
            quantidades: value.quantidades,
            setInsumoSelecionado: value.setInsumoSelecionado,
            setQuantidades: value.setQuantidades,
            setAltInsumo: value.setAltInsumo,
        }),
        [
            value.insumoSelecionado,
            value.insumosSelecionados,
            value.fichaTecnica,
            value.quantidades,
            value.setInsumoSelecionado,
            value.setQuantidades,
            value.setAltInsumo,
        ]
    )

    const modalState = useMemo(
        () => ({
            setOpenproduto: value.setOpenproduto,
            setOpenCategoria: value.setOpenCategoria,
            setCadastrar: value.setCadastrar,
            setModalCategoria: value.setModalCategoria,
            setModalProduto: value.setModalProduto,
            setModalPasso: value.setModalPasso,
            setOpenPassoDeMontagem: value.setOpenPassoDeMontagem,
            setCategoriaAtual: value.setCategoriaAtual,
            setProdutoAtual: value.setProdutoAtual,
            setSalvarCardapioCompleto: value.setSalvarCardapioCompleto,
        }),
        [
            value.setOpenproduto,
            value.setOpenCategoria,
            value.setCadastrar,
            value.setModalCategoria,
            value.setModalProduto,
            value.setModalPasso,
            value.setOpenPassoDeMontagem,
            value.setCategoriaAtual,
            value.setProdutoAtual,
            value.setSalvarCardapioCompleto,
        ]
    )

    const contextValue = useMemo(
        () => ({
            ...handlers,
            ...staticData,
            ...fichaTecnicaState,
            ...modalState,
        }),
        [handlers, staticData, fichaTecnicaState, modalState]
    )

    return <CardapioContext.Provider value={contextValue}>{children}</CardapioContext.Provider>
}
